import { gql, type TypedDocumentNode } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS } from '@sorare/core/src/atoms/typography';

import { CollectionSlotsStats } from '#src/components/collections/CollectionPreview/CollectionSlotsStats/index.tsx';
import type { LeagueCollectionPreviewHeader_cardCollection } from './__generated__/index.graphql.ts';

const Root = styled(Horizontal)`
  height: 100%;
  overflow: hidden;
`;
const ClubLogo = styled.img`
  height: 32px;
  object-fit: contain;
`;

const Name = styled(HeadlineS)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RightContent = styled(Horizontal)`
  flex: 1;
  overflow: hidden;
  flex-wrap: wrap;
  justify-content: space-between;
`;

type Props = {
  cardCollection: Nullable<LeagueCollectionPreviewHeader_cardCollection>;
};

export const LeagueCollectionPreviewHeader = ({ cardCollection }: Props) => {
  const { anyTeam, userCardCollection } = cardCollection || {};
  const { pictureUrl, shortName } = anyTeam || {};

  return (
    <Root>
      {!!pictureUrl && <ClubLogo src={pictureUrl} alt="" />}
      <RightContent gap={0.5}>
        <Name>{shortName}</Name>
        <CollectionSlotsStats
          cardSetSlug={cardCollection?.cardSet?.slug}
          userCardCollection={userCardCollection}
        />
      </RightContent>
    </Root>
  );
};

LeagueCollectionPreviewHeader.fragments = {
  cardCollection: gql`
    fragment LeagueCollectionPreviewHeader_cardCollection on CardCollection {
      slug
      cardSet {
        slug
      }
      anyTeam {
        slug
        shortName
        pictureUrl(derivative: "avatar")
        styleGuideColor
      }
      userCardCollection(forUserSlug: $user) {
        id
        ...CollectionSlotsStats_userCardCollection
      }
    }
    ${CollectionSlotsStats.fragments.userCardCollection}
  ` as TypedDocumentNode<LeagueCollectionPreviewHeader_cardCollection>,
};
